import React from 'react'
import './section-your-confidant.scss'

import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const SectionYourConfidant = () => {
  const { allContentfulVConfidentHome } = useStaticQuery(
    graphql`
      query yourConfidant {
        allContentfulVConfidentHome {
          nodes {
            node_locale
            paisesDeRestriccion
            informacionSomosTuConfidente {
              raw
            }
            imagenSomosTuConfidente {
              gatsbyImageData
            }
          }
        }
      }
    `
  )

  const contentInfo = allContentfulVConfidentHome.nodes.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  const optiondRender = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, next) => (
        <h2 className="f-section-your-confidant__description__title">{next}</h2>
      ),
      [BLOCKS.PARAGRAPH]: (node, next) => (
        <p className="f-section-your-confidant__description__txt">{next}</p>
      ),
    },
  }

  return (
    <section className="f-section-your-confidant">
      <div className="f-section-your-confidant__wrapper">
        <div className="f-section-your-confidant__img">
          <GatsbyImage
            image={getImage(contentInfo.imagenSomosTuConfidente[0])}
            alt="Somos tu confidente"
          />
        </div>
        {documentToReactComponents(
          JSON.parse(contentInfo.informacionSomosTuConfidente.raw),
          optiondRender
        )}
      </div>
    </section>
  )
}

export default SectionYourConfidant
